__turbopack_context__.v({
  "className": "inter_ba2c517d-module__5s09Wa__className",
});
